exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-hover{width:100%;table-layout:fixed}.table-sm{font-size:14px}", ""]);

// exports
